import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useSaveHeartFailureMutation } from "app/store/transmission/api/transmissionTableApi";
import { showToast } from "utils/toast";

const useHeartFailure = () => {
  const { profile, patientSerialNumber } = useSelector(
    (state) => state.transmission
  );
  const [saveHeartFailure, { isSuccess, isError, error, data: updatedData }] =
    useSaveHeartFailureMutation();

  useEffect(() => {
    isError && error && showToast({ message: error?.message, type: "error" });

    if (isSuccess && updatedData) {
      const message = `Changed Successfully HF set to ${
        profile?.sub_account ? false : true
      }`;

      showToast({ message });
    }
  }, [updatedData, error]);

  const handleClick = (e) => {
    saveHeartFailure(patientSerialNumber);

    const message = `Changed Successfully HF set to ${
      profile?.sub_account ? false : true
    }`;

    showToast({ message });
  };

  return { profile, handleClick };
};

export default useHeartFailure;
